<form #rppForm="ngForm" id="rppForm" novalidate autocomplete="off" class="modal-form-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{ modalTitle }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         (click)="minimise = !minimise"></i>
      <i class="fa fa-times" (click)="cancel()"></i>
    </div>
  </div>

  <!-- Modal Body (Scrollable) -->
  <div class="modal-body modal-body-scrollable" [hidden]="minimise">
      <!-- Payor Selection -->
      <div class="form-row">
        <div class="form-group col-md-5">
          <label><strong>Select Payor:</strong></label>
          <!-- Hidden input for form validation -->
          <input 
            type="hidden"
            [(ngModel)]="selectedPayor"
            name="payor"
            required />
          @if (!loadingPayor) {
<div class="loading-spinner">
            <i class="fa fa-spinner fa-spin"></i>
          </div>
}
          @if (loadingPayor) {
<div class="custom-dropdown-wrapper">
            <!-- Custom dropdown trigger -->
            <div class="custom-dropdown-trigger" (click)="togglePayorDropdown()">
              <input 
                type="text" 
                class="form-control"
                [value]="selectedPayor ? selectedPayor.PAYOR : ''"
                placeholder="Select Payor..."
                readonly />
              <i class="fa fa-chevron-down dropdown-chevron" [class.open]="payorDropdownOpen"></i>
            </div>
            
            <!-- Dropdown panel -->
            @if (payorDropdownOpen) {
<div class="custom-dropdown-panel" (click)="$event.stopPropagation()">
              <!-- Search box inside dropdown -->
              <div class="dropdown-search">
                <input 
                  type="text" 
                  class="form-control input-sm"
                  [(ngModel)]="payorSearchText"
                  (ngModelChange)="filterPayor()"
                  placeholder="Search Payor..."
                  name="payorSearch"
                  #payorSearchInput />
                <i class="fa fa-search search-icon"></i>
              </div>
              
              <!-- Scrollable list with lazy loading -->
              <ul class="dropdown-list" (scroll)="onPayorScroll($event)">
                @for (payor of filteredPayorList; track $index) {
<li 
                 
                  (click)="selectPayor(payor)"
                  [class.selected]="selectedPayor?.LEID === payor.LEID">
                  {{ payor.PAYOR }}
                </li>
}
                @if (filteredPayorList.length === 0) {
<li class="no-results">
                  <i>No results found</i>
                </li>
}
              </ul>
              
              <!-- Footer with counts - HIDDEN per Issue 7 -->
              <!-- <div class="dropdown-footer">
                <small class="text-muted">
                  Showing {{ filteredPayorList.length }} of {{ payorFilteredTotal }} | 
                  Total: {{ payorList.length }}
                </small>
              </div> -->
            </div>
}
          </div>
}
        </div>
      </div>

      <!-- Recipient Selection -->
      <div class="form-row">
        <div class="form-group col-md-5">
          <label><strong>Select Recipient:</strong></label>
          <!-- Hidden input for form validation -->
          <input 
            type="hidden"
            [(ngModel)]="selectedRecipient"
            name="recipient"
            required />
          @if (!loadingRecipient) {
<div class="loading-spinner">
            <i class="fa fa-spinner fa-spin"></i>
          </div>
}
          @if (loadingRecipient) {
<div class="custom-dropdown-wrapper">
            <!-- Custom dropdown trigger -->
            <div class="custom-dropdown-trigger" (click)="toggleRecipientDropdown()">
              <input 
                type="text" 
                class="form-control"
                [value]="selectedRecipient ? selectedRecipient.RECIPIENT : ''"
                placeholder="Select Recipient..."
                readonly />
              <i class="fa fa-chevron-down dropdown-chevron" [class.open]="recipientDropdownOpen"></i>
            </div>
            
            <!-- Dropdown panel -->
            @if (recipientDropdownOpen) {
<div class="custom-dropdown-panel" (click)="$event.stopPropagation()">
              <!-- Search box inside dropdown -->
              <div class="dropdown-search">
                <input 
                  type="text" 
                  class="form-control input-sm"
                  [(ngModel)]="recipientSearchText"
                  (ngModelChange)="filterRecipient()"
                  placeholder="Search Recipient..."
                  name="recipientSearch"
                  #recipientSearchInput />
                <i class="fa fa-search search-icon"></i>
              </div>
              
              <!-- Scrollable list with lazy loading -->
              <ul class="dropdown-list" (scroll)="onRecipientScroll($event)">
                @for (recipient of filteredRecipientList; track $index) {
<li 
                 
                  (click)="selectRecipient(recipient)"
                  [class.selected]="selectedRecipient?.LEID === recipient.LEID">
                  {{ recipient.RECIPIENT }}
                </li>
}
                @if (filteredRecipientList.length === 0) {
<li class="no-results">
                  <i>No results found</i>
                </li>
}
              </ul>
              
              <!-- Footer with counts - HIDDEN per Issue 7 -->
              <!-- <div class="dropdown-footer">
                <small class="text-muted">
                  Showing {{ filteredRecipientList.length }} of {{ recipientFilteredTotal }} | 
                  Total: {{ recipientList.length }}
                </small>
              </div> -->
            </div>
}
          </div>
}
        </div>
      </div>

      <!-- Payment Type and Date -->
      <div class="form-row">
        <div class="form-group col-md-5">
          <label><strong>Select Payment Type:</strong></label>
          <select 
            class="form-control"
            [(ngModel)]="selectedPaymentType"
            (ngModelChange)="onPaymentTypeChange()"
            name="paymentType"
            required>
            <option [ngValue]="null">Select Payment Type</option>
            @for (type of paymentTypes; track $index) {
<option [ngValue]="type">
              {{ type.DESCRIPTION }}
            </option>
}
          </select>
        </div>

        <div class="form-group col-md-5">
          <label><strong>Payment Date:</strong></label>
          <input 
            type="date" 
            class="form-control date-input-no-placeholder"
            [(ngModel)]="dateSelected"
            name="paymentDate"
            (ngModelChange)="formatDate()"
            required />
          @if (dateFlag) {
<span class="form-error-container">
            Date year should be {{ globalParams.tax_year || filterParams.tax_year }}
          </span>
}
        </div>
      </div>

      <!-- Functional Currency of Payor -->
      <div class="form-row">
        <div class="form-group col-md-6">
          <b>Functional Currency of Payor:</b> 
          @if (selectedPayor) {
<span>
            {{ selectedPayor.FUNCTIONAL_CURRENCY }} - {{ selectedPayor.FUNCTIONAL_CURRENCY_DESC }}
          </span>
}
        </div>
      </div>

      <!-- Amount Paid -->
      <div class="form-row">
        <div class="form-group col-md-5">
          <label><strong>Amount Paid:</strong></label>
          <input 
            type="number"
            class="form-control text-right"
            [(ngModel)]="amountPaid"
            name="amountPaid"
            (blur)="validateAmt(amountPaid, selectedPayor?.WTD_AVG_RATE || 1, 'PAIDOBJ', 'cur_adj_amt', 'payor_amt')"
            [disabled]="isAmtPaidDisabled()" />
        </div>

        <div class="form-group col-md-5">
          <label><strong>Amount Paid (in USD):</strong></label>
          <div class="input-group">
            <input 
              type="number"
              class="form-control text-right disabled-usd-field"
              [(ngModel)]="amountPaid2"
              name="amountPaidUsd"
              readonly />
            <span class="input-group-addon">USD</span>
          </div>
        </div>
      </div>

      <!-- Functional Currency of Recipient -->
      <div class="form-row">
        <div class="form-group col-md-6">
          <b>Functional Currency of Recipient:</b> 
          @if (selectedRecipient) {
<span>
            {{ selectedRecipient.FUNCTIONAL_CURRENCY }} - {{ selectedRecipient.FUNCTIONAL_CURRENCY_DESC }}
          </span>
}
        </div>
      </div>

      <!-- Amount Received -->
      <div class="form-row">
        <div class="form-group col-md-5">
          <label><strong>Amount Received (in FC of Recipient):</strong></label>
          <input 
            type="number"
            class="form-control text-right"
            [(ngModel)]="amountReceived"
            name="amountReceived"
            (ngModelChange)="makeAmountReceivedNegative()"
            (blur)="validateAmt(amountReceived, selectedRecipient?.WTD_AVG_RATE || 1, 'RECEIVEDOBJ', 'receive_adj_amt', 'payee_amt')"
            [disabled]="isAmtReceivedDisabled()" />
        </div>

        <div class="form-group col-md-5">
          <label><strong>Amount Received (in USD):</strong></label>
          <div class="input-group">
            <input 
              type="number"
              class="form-control text-right disabled-usd-field"
              [(ngModel)]="amountReceived2"
              name="amountReceivedUsd"
              readonly />
            <span class="input-group-addon">USD</span>
          </div>
        </div>
      </div>

      <!-- Withholding Tax -->
      <div class="form-row">
        <div class="form-group col-md-5">
          <label><strong>Withholding Tax (in FC of Recipient):</strong></label>
          <input 
            type="number"
            class="form-control text-right"
            [(ngModel)]="withholdingTax"
            name="withholdingTax"
            [disabled]="isWithholdingTaxDisabled()" />
        </div>
      </div>

      <!-- US Foreign Indicator -->
      <div class="form-row">
        <div class="form-group col-md-5">
          <label><strong>Select US Foreign Indicator:</strong></label>
          <select 
            class="form-control"
            [(ngModel)]="selectedUsForeignInd"
            name="usForeignInd"
            required>
            <option [ngValue]="null">Select</option>
            @for (ind of usForeignIndList; track $index) {
<option [ngValue]="ind">
              {{ ind.code }}
            </option>
}
          </select>
          @if (usForeignIndRequired) {
<span class="form-error-container">
            This field is required.
          </span>
}
        </div>
      </div>

      <!-- Is the Recipient a Shareholder? -->
      <div class="form-row">
        <div class="form-group col-md-6">
          <b>Is the Recipient a Shareholder?</b>
        </div>
      </div>

      <!-- Is this a Cash Payment? -->
      <div class="form-row">
        <div class="form-group col-md-12">
          <div class="radio-group-inline">
            <label class="radio-label"><b>Is this a Cash Payment?</b></label>
            <div class="radio-options-inline">
              <label>
                <input 
                  type="radio" 
                  name="cashPaymentRadio" 
                  [checked]="cashPayment === 'Y'"
                  (change)="setCashPayment('Y')" />
                Yes
              </label>
              <label>
                <input 
                  type="radio" 
                  name="cashPaymentRadio" 
                  [checked]="cashPayment === 'N'"
                  (change)="setCashPayment('N')" />
                No
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Tax Basis Value (shown when Cash Payment = No) -->
      @if (cashPayment === 'N') {
<div class="form-row">
        <div class="form-group col-md-4">
          <label class="control-label">Tax Basis Value:</label>
          <div class="input-group">
            <input 
              type="number"
              class="form-control text-right"
              [(ngModel)]="taxBaseVal"
              name="taxBaseVal"
              (blur)="validateAmt(taxBaseVal, selectedPayor?.WTD_AVG_RATE || 1, 'CASHDISTOBJ', 'TAX_BASE_VAL_USD', 'tax_base_val')" />
            <span class="input-group-addon">
              {{ selectedPayor?.FUNCTIONAL_CURRENCY_DESC || '' }}
            </span>
          </div>
          @if (invalidTaxBaseVal) {
<span class="form-error-container">
            Amount should not be negative.
          </span>
}
        </div>

        <div class="form-group col-md-4">
          <label>&nbsp;</label>
          <div class="input-group">
            <input 
              type="number"
              class="form-control text-right"
              [(ngModel)]="taxBaseValUsd"
              name="taxBaseValUsd"
              readonly />
            <span class="input-group-addon">USD</span>
          </div>
        </div>
      </div>
}

      <!-- Principal Place of Business of Recipient -->
      <div class="form-row">
        <div class="form-group col-md-6">
          <b>Principal Place of Business of Recipient:</b>
        </div>
      </div>

      <!-- Same Country Eligible? -->
      <div class="form-row">
        <div class="form-group col-md-12">
          <div class="radio-group-inline">
            <label class="radio-label"><b>Same Country Eligible?</b></label>
            <div class="radio-options-inline">
              <label>
                <input 
                  type="radio" 
                  [(ngModel)]="countryEligible" 
                  name="countryEligible" 
                  value="Y"
                  (ngModelChange)="countryEligibleChange()" />
                Yes
              </label>
              <label>
                <input 
                  type="radio" 
                  [(ngModel)]="countryEligible" 
                  name="countryEligible" 
                  value="N"
                  (ngModelChange)="countryEligibleChange()" />
                No
              </label>
              <label>
                <input 
                  type="radio" 
                  [(ngModel)]="countryEligible" 
                  name="countryEligible" 
                  value="S"
                  (ngModelChange)="countryEligibleChange()" />
                Section 954(c)(6)
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Validation Messages -->
      <div class="form-row">
        <div class="form-group col-md-12">
          @if (payorRequired) {
<span class="form-error-container">
            Select Payor is required.
          </span>
}
          @if (recipientRequired) {
<span class="form-error-container">
            Select Recipient is required.
          </span>
}
        </div>
      </div>
  </div>

  <!-- Modal Footer (Fixed at bottom) -->
  <div class="modal-footer modal-footer-fixed" [hidden]="minimise">
    <button 
      class="save-button" 
      type="button" 
      (click)="saveNewPayment()"
      [disabled]="crudLoading || rppForm.invalid || invalidTaxBaseVal">
      @if (crudLoading) {
<span>
        <i class="fa fa-spinner fa-pulse"></i>
      </span>
}
      Save
    </button>
    <button 
      class="cancel-button" 
      type="button" 
      (click)="cancel()">
      Cancel
    </button>
  </div>
</form>

